import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import { WhatsAppIcon } from "@/components/Icon";
import { WA_DEFAULT } from "@/data/site";

export const MobileCTA = () => (
  <>
    <div
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-white/10 bg-charcoal px-3 pt-3 md:hidden"
      style={{ paddingBottom: "calc(12px + env(safe-area-inset-bottom))" }}
      data-testid="mobile-cta-bar"
    >
      <a href={WA_DEFAULT} target="_blank" rel="noopener noreferrer" className="btn min-h-[48px] border border-white/25 text-ivory" data-testid="mobile-cta-whatsapp">
        <WhatsAppIcon className="h-4 w-4" /> WhatsApp
      </a>
      <Link to="/contact#inquiry" className="btn min-h-[48px] bg-rust-deep text-white" data-testid="mobile-cta-quote">
        <FileText className="h-4 w-4" /> Get a Quote
      </Link>
    </div>
    <a
      href={WA_DEFAULT}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Industrix Solution on WhatsApp"
      className="group fixed bottom-6 right-6 z-40 hidden h-14 items-center gap-0 overflow-hidden rounded-full bg-charcoal pl-4 pr-4 text-ivory shadow-[0_20px_40px_-15px_rgba(39,41,35,.6)] transition-[padding,background-color] duration-300 hover:bg-rust-deep hover:pr-6 md:inline-flex"
      data-testid="floating-whatsapp-btn"
    >
      <WhatsAppIcon className="h-6 w-6" />
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-[max-width,margin] duration-300 group-hover:ml-3 group-hover:max-w-[160px] group-focus-visible:ml-3 group-focus-visible:max-w-[160px]">Chat on WhatsApp</span>
    </a>
  </>
);
